/* eslint-disable @typescript-eslint/no-explicit-any */
import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';
import { IEveryDoggyAPIServices } from '../../../utils/services/EveryDoggyAPIServices';
import OneLinkParametersHelper from '../../../utils/services/OneLinkParametersComposer';
import { IAppleGoogleViewModel } from './types';
import {analyticsEventsTracker, EVENT_TRACKERS, GTMQuizFunnelEvent, GTMOnboardingFunnelEvent } from '../../../utils/analytics';
import { extractEmailFromUrl } from '../../../utils/scripts/extractEmailFromUrl';
import getAmplitudeDeviceId from '../../../utils/scripts/amplitudeDeviceId';

const ComposeAppleGoogleViewModel = (
	sourceURL: string,
	apiServices: IEveryDoggyAPIServices,
	errorLogger: IErrorLoggerWithUserSupport,
): IAppleGoogleViewModel => {

	const oneLinkParametersHelper = OneLinkParametersHelper;

	const getStripeKey = async () => {
		let data = await apiServices.getStripeConfig();
		if (!data) data = await apiServices.getStripeConfig();
		if (!data?.publishableKey) {
			throw new Error('Stripe config unavailable');
		}
		return data.publishableKey;
	};

	const processPaymentAction = (
		paymentMethodId: string,
		stripePlanId: string, 
		email: string,
		internalId: string,
		productAmount?: string,
		productName?: string,
		paymentSystem?: string,
		answers?: any,
		showChatUpsale?: boolean,
	) => {

		const dataToSend = {
			amplitude_device_id: getAmplitudeDeviceId(),
			payment_method_id: paymentMethodId,
			stripe_plan_id: stripePlanId,
			email,
      internal_id: internalId,
			fbclickid: oneLinkParametersHelper.getFBclickId(sourceURL),
			fbp: oneLinkParametersHelper.getFBp(sourceURL),
			source_url: sourceURL,
			onboarding_email: extractEmailFromUrl() || email,
			...(answers !== null && answers !== undefined && { 'onboarding_answers': answers }),
		};

		return apiServices.createStripeSubscription(dataToSend, paymentSystem, productName, productAmount, email)
			.then(_ => apiServices.checkoutStripeSubscription(email))
			.then((result) => {
				let event;

				if (showChatUpsale) {
					event = GTMOnboardingFunnelEvent.paymentSuccessfulChat(
						productName,
						paymentSystem,
						productAmount,
					);
				} else {
					event = GTMQuizFunnelEvent.paymentSuccessful({
						paymentType: paymentSystem,
						trialPrice: `${productAmount}`,
						productName: `${productName}`,
						'email': email,
					});
				}
				
				analyticsEventsTracker.trackWithTarget(event, EVENT_TRACKERS.GTM);
				//FIXME: validate URL
				const url = result.redirect_url;
				return { url };
			});
	};

	const processPaymentCancel = async () => {
		errorLogger.logMessage('stripe payment cancelled');
	};

	const processPaymentError = async (error: any) => {
		errorLogger.logError({
			name: 'Stripe error',
			message: JSON.stringify(error)
		});
	};

	return {
		getStripeKey,
		processPaymentCancel,
		processPaymentError,
		processPaymentAction,
	};
};

export default ComposeAppleGoogleViewModel;